import SmartAutocompleteBase from "../assets/SmartAutocompleteBase";
import * as constants from "../assets/constants";
import SalePoint from "../references/Klients/salePoint";
import React from "react";
import {Div, Title} from "@vkontakte/vkui";

class MallSmartAutocomplete extends SmartAutocompleteBase {

    renderCreateForm() {
        const base_url = constants.DEBUG ? constants.base_url_stage : constants.base_url_prod
        return <div>
            <Div><Title>Добавить торговый объект</Title></Div>
            <SalePoint
                no_panel_header
                no_reload_klient
                noStickedActions
                current_user={this.state.current_user}
                base_url={base_url}
                item={this.state.current_object}
                change={this.editCurrentSalePoint}
                hideForm={() => this.closeCreateForm()}
                onCreate={(value) => {
                    value.descr = value.full_address
                    this.setState({current_object: value})
                    window.postMessage({type: 'newMallCreated', value})
                    window.postMessage('closeSmartAutocomplete' + this.guid)
                }}
            />
        </div>
    }

    createAction() {
        super.createAction()

        const value = {
            //id: -1,
            klient_id: null,
            mall_id: null,
            isMall: 1,
            comment: '', info: ''
        }
        this.setState({current_object: value})

        window.postMessage({
            type: 'setCurrentMall',
            value
        })
        window.postMessage({
            type: 'setCurrentAddField',
            value: 'mall'
        })
    }

    closeCreateForm() {
        super.closeCreateForm()
        window.postMessage({
            type: 'setCurrentAddField',
            value: null
        })
    }

    editCurrentSalePoint = (e, fieldName) => {
        const {current_object} = this.state
        ///console.log(e)
        if (e.unrestricted_value !== undefined) {
            current_object.dadata_object = e
            current_object.full_address = e.value
        } else {
            current_object[fieldName] = e.currentTarget.value
        }
        this.setState({current_object})
    }

}

export default MallSmartAutocomplete